// function waitForElement(selector, callback) {
//   const timeout = 5000; // 5 seconds
//   const intervalTime = 100; // Interval check every 100ms
//   let elapsedTime = 0;

//   const interval = setInterval(() => {
//     const element = document.querySelector(selector);

//     if (element) {
//       clearInterval(interval); // Stop checking
//       callback(element); // Execute the callback function with the found element
//     } else if (elapsedTime >= timeout) {
//       clearInterval(interval); // Stop checking after timeout
//       console.warn(`Element not found within ${timeout / 1000} seconds.`);
//     } else {
//       elapsedTime += intervalTime;
//     }
//   }, intervalTime);
// }

// function addGiftBox() {
//   jQuery(document).ready(() => {
//     jQuery(".item").each(function (index, el) {
//       if (jQuery(el).find(".giftWrapWrapper").length == 0) {
        
//         jQuery(el).find(".item-container").after(`
//           <div class="giftWrapWrapper" style="margin-top: 12px;">
//   <div
//     class="giftWrap"
//     style="background-color: #f7f7f7; border-radius: 12px; padding: 8px"
//   >
//     <label
//       class="giftWrapHeading"
//       style="
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         cursor: pointer;
//         font-size: 14px;
//         font-weight: 600;
//       "
//     >
//       Add Gift Wrapping for $2.49
//       <input
//         style="display: none"
//         type="checkbox"
//         name="giftWrapCheck"
//         id="giftWrapCheck"
//         style="appearance: auto"
//       />
//       <span></span>
//     </label>

//     <div class="giftWrapOptions" style="display: none">
//       <div style="margin: 8px 0; font-size: 14px; color: #5b5b5be5 !important;">Select the pattern of gift wrapping:</div>

//       <form>
//         <label
//           class="giftWrapSingle"
//           style="
//             cursor: pointer;
//             display: flex;
//             align-items: center;
//             justify-content: space-between;
//             margin-bottom: 8px;
//           "
//         >
//           <div style="display: flex; align-items: center; gap: 8px;">
//             <input
//               type="radio"
//               name="giftWrapRadio"
//               id="silver"
//               style="appearance: auto"
//               checked
//             />
//             <img src="https://cdn.shopify.com/s/files/1/0626/3154/3121/files/2_c55876b8-bfd1-4572-bd06-1b418c7df9aa.png?v=1729531225" alt="" width="48" height="48" />
//             Silver
//           </div>
//           <div>$2.49</div>
//         </label>

//         <label
//           class="giftWrapSingle"
//           style="
//             cursor: pointer;
//             display: flex;
//             align-items: center;
//             justify-content: space-between;
//           "
//         >
//           <div style="display: flex; align-items: center; gap: 8px;">
//             <input
//               name="giftWrapRadio"
//               type="radio"
//               id="christmas"
//               style="appearance: auto"
//             />
//             <img src="https://cdn.shopify.com/s/files/1/0626/3154/3121/files/1_1714bcdb-7e57-4f9a-a06f-783722f93f72.png?v=1729531250" alt="" width="48" height="48" />
//             Christmas
//           </div>
//           <div>$2.49</div>
//         </label>
//       </form>

//       <button
//         class="applyGift"
//         style="
//           margin-left: auto;
//           display: block;
//           width: 125px;
//           text-align: center;
//           background: #f04f36;
//           color: white;
//           padding: 8px 0;
//           border-radius: 4px;
//         "
//       >
//         Apply
//       </button>
//     </div>
//   </div>
// </div>
//         `);
//         if (jQuery(el).find('wrapped-extension wrapped-feature-checkbox-simple input:checked').length != 0) {
//           jQuery('.item').find('#giftWrapCheck').prop('checked', true);
//         }
//       } else{
//         if (jQuery(el).find('wrapped-extension wrapped-feature-checkbox-simple input:checked').length != 0) {
//           jQuery(el).find('#giftWrapCheck').prop('checked', true);
//         } else{
//           jQuery(el).find('#giftWrapCheck').prop('checked', false);
//         }
//       }
//     });
//   });
// }

// const cartEventRefresh = new Event("cartRefresh");
// document.addEventListener("cartRefresh", (e) => {
//   console.log("refreshed");
//   addGiftBox();
//   SLIDECART_UPDATE();
// });


// document.addEventListener("click", function (e) {
//   if (e.target.className == "applyGift") {
//     if (!jQuery(e.target).parents(".item").find("wrapped-feature-checkbox-simple input").prop('checked')) {
//       jQuery(e.target)
//       .parents(".item")
//       .find("wrapped-feature-checkbox-simple input")
//       .trigger("click");
//     }
//     let checkWrap = jQuery(e.target).parents(".item").find('input[name="giftWrapRadio"]:checked').attr('id');
//     if (checkWrap == 'silver') {
//       jQuery(e.target).parents(".item").find('input[value="49803245814097"]').click();
//     } else if (checkWrap == 'christmas') {
//       jQuery(e.target).parents(".item").find('input[value="49803242471761"]').click();
//     }
//     jQuery(e.target).parents(".item").find('.giftWrapOptions').css('display','none');
//   } else if (e.target.id == "giftWrapCheck" && e.target.checked) {
//     jQuery(e.target)
//       .parents(".giftWrapWrapper")
//       .find(".giftWrapOptions")
//       .css("display", "block");
//   } else if (e.target.id == "giftWrapCheck" && !e.target.checked) {
//     jQuery(e.target)
//       .parents(".giftWrapWrapper")
//       .find(".giftWrapOptions")
//       .css("display", "none");
//     if (jQuery(e.target).parents(".item").find("wrapped-feature-checkbox-simple input").prop('checked')) {
//       jQuery(e.target)
//       .parents(".item")
//       .find("wrapped-feature-checkbox-simple input")
//       .trigger("click");
//     }
//   }
// });

// window.SLIDECART_REMOVED_FROM_CART = function({ id }) {
//   addGiftBox();
// }

// window.SLIDECART_OPENED = function() {
//   window.Wrapped.buildExtensions(!0);
//   addGiftBox();
// }

window.SLIDECART_LOADED = function (cart) {
  console.log(cart, 'loaded');
  SLIDECART_UPDATE();
  document.querySelector('.product-form__submit').disabled = false;
  
  // window.Wrapped.buildExtensions(!0)
  // addGiftBox();
};

// window.SLIDECART_UPDATED = function(cart) {
//   console.log(cart);
//   addGiftBox();
// }


window.SLIDECART_UPDATED = async function(cart) {
  var newCart = cart
  var total = 0

  for(var i = 0; i < newCart.items.length; i++) {
    var item = newCart.items[i]  
    var res = await axios.get('/products/' + item.handle + '.js')
    var variant = res.data.variants.find(i => i.id == item.variant_id)
    var compare = variant.compare_at_price
    
    total += (compare - variant.price) * item.quantity
    newCart.items[i].original_line_price = compare * item.quantity

  }
  
  newCart.total_discount = total
  window.SLIDECART_SET_CART(newCart)
}


let isDown = false;
let startX;
let scrollLeft;

document.addEventListener('mousedown', (e) => {
  const slider = e.target.closest('.upsells-stacked');
  if (!slider) return;

  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;

  // Add mousemove listener to the document for dragging effect
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
});

function onMouseMove(e) {
  if (!isDown) return;
  const slider = document.querySelector('.upsells-stacked.active');
  if (!slider) return;

  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 2; // Adjust scroll speed
  slider.scrollLeft = scrollLeft - walk;
}

function onMouseUp() {
  isDown = false;
  const slider = document.querySelector('.upsells-stacked.active');
  if (slider) {
    slider.classList.remove('active');
  }

  // Remove mousemove and mouseup listeners to prevent unwanted events
  document.removeEventListener('mousemove', onMouseMove);
  document.removeEventListener('mouseup', onMouseUp);
}
